// Support Configuration for Tibbbi
// Replace these with your actual business contact information

export const supportConfig = {
  // WhatsApp Business Number
  // Format: Include country code without + or spaces
  // Example: '218911234567' for Libya
  whatsapp: {
    number: '1234567890', // Replace with your WhatsApp Business number
    defaultMessage: {
      en: 'Hello, I need help finding a page on Tibbbi.',
      ar: 'مرحباً، أحتاج إلى المساعدة في العثور على صفحة على طبّي.',
      he: 'שלום, אני צריך עזרה במציאת דף בטיבי.',
      fr: "Bonjour, j'ai besoin d'aide pour trouver une page sur Tibbbi."
    }
  },

  // Facebook Messenger
  // Your Facebook page username or ID
  messenger: {
    pageId: 'tibbbi.health', // Replace with your Facebook page ID
  },

  // Email support (optional)
  email: 'support@tibbbi.com',

  // Analytics endpoint for error reporting
  errorReporting: {
    endpoint: '/api/errors/404', // Replace with your analytics endpoint
    enabled: true
  }
};